import { cx } from "@jugl-web/utils";
import { FC } from "react";
import { PlainButton } from "../../primitives/PlainButton";
import { ReactComponent as ArrowLeftIcon } from "./icons/arrow-left.svg";
import { FullScreenHeaderProps } from "./types";

export const FullScreenHeader: FC<FullScreenHeaderProps> = ({
  title,
  isDetached,
  className,
  onClose,
}) => (
  <header
    className={cx(
      "flex items-center gap-4 px-4 pb-4 pt-5",
      isDetached &&
        "border border-t-0 border-l-0 border-r-0 border-solid border-[#F6F6F6]",
      className
    )}
  >
    <PlainButton onClick={onClose}>
      <ArrowLeftIcon />
    </PlainButton>
    <h3 className="text-dark font-secondary m-0 text-lg font-medium leading-4">
      {title}
    </h3>
  </header>
);
